module.exports = new __parcel__URL__("compositionalIT.28036615.png").toString();